import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";
import {Mental} from "../Mental";

export interface IWinFramePosition {
    reelId: number;
    symbolId: number;
    innerSymbolId: number;
    symbolHeight: number;
    animName: string;
    singleSymbolInEnhancer: boolean;
    winFrameIndex: number;
    resizedReel: boolean;
    timeScale: number;
}

export class MentalWinHighlightView extends PIXI.Container implements StageLayer {
    private _winItems: PIXI.spine.Spine[] = [];

    constructor() {
        super();
        this.init();
    }

    public playInitialWinAnimation(winFrameData: IWinFramePosition): void {
        const reelId: number = winFrameData.reelId,
            winFrameIndex: number = winFrameData.winFrameIndex,
            symId: number = winFrameData.symbolId,
            resizedReel: boolean = winFrameData.resizedReel,
            isSingleSymInEnhancer: boolean = winFrameData.singleSymbolInEnhancer,
            animName: string = winFrameData.animName,
            winItem: PIXI.spine.Spine = this._winItems[winFrameIndex];

        let usableHeight: number = winFrameData.symbolHeight;

        if ((reelId === 1 || reelId === 3) && symId === 2 && !resizedReel) {
            usableHeight = isSingleSymInEnhancer ? 99 : 45;
        }
        MentalWinHighlightView.resetWinItemTemp(winItem, winFrameData);

        winItem.state.setAnimation(0, animName, false).timeScale = winFrameData.timeScale;

        // we have to set the height after setting the state, and we need the updateTransform method to let this height take effect.
        winItem.height = (usableHeight * 1.70772727);
        winItem.updateTransform();
    }

    private static resetWinItemTemp(winItem: PIXI.spine.Spine, winFrameData: IWinFramePosition): void {
        const reelId: number = winFrameData.reelId,
            symId: number = winFrameData.symbolId,
            height: number = winFrameData.symbolHeight,
            innerSymId: number = winFrameData.innerSymbolId,
            resizedReel: boolean = winFrameData.resizedReel,
            isSingleSymInEnhancer: boolean = winFrameData.singleSymbolInEnhancer;

        const reelAreaTop: number = 90,
            extraY: number = (reelId % 2 !== 0 ? (height / 2 + 99) : (height / 2)) + reelAreaTop, // 99 is the top offset for 2nd and 4th reel that have space for 2 symbols.
            symWidth: number = 144,
            xPos: number = ((symWidth / 2) + (symWidth * reelId));

        let yPos: number;

        if (resizedReel) { // on for xWays reels
            yPos = MentalWinHighlightView.yPosForResizedReel(reelId, height, symId, innerSymId) + extraY;
        } else if ((reelId === 1 || reelId === 3) && symId === 2) { // enhancer specific
            if (isSingleSymInEnhancer) {
                yPos = 629.5;
            } else {
                yPos = (611.5 + (innerSymId * 45));
            }
        } else { // other symbols split and normal  both
            yPos = ((symId * 198) + innerSymId * height) + extraY;
        }

        winItem.skeleton.setSlotsToSetupPose();
        winItem.skeleton.setToSetupPose();
        winItem.state.clearTracks();
        winItem.state.setEmptyAnimation(0, 0);

        winItem.position.set(xPos, yPos);

        if (!winItem.visible) {
            winItem.visible = true;
            winItem.updateTransform();
        }
    }

    /**
     * working perfectly fine in case of resized reel
     * @param reelId
     * @param height
     * @param symId
     * @param innerSymId
     * @private
     */
    private static yPosForResizedReel(reelId: number, height: number, symId: number, innerSymId: number): number {
        let totalPreviousSymbol: number = 0;
        for (let i: number = 0; i < symId; i++) {
            totalPreviousSymbol += Mental.model.gameData.currentSymbolSize[reelId][i]
        }
        totalPreviousSymbol += innerSymId;
        return totalPreviousSymbol * height;
    };

    public playToggleAnimation(winFrameData: IWinFramePosition): void {
        const reelId: number = winFrameData.reelId,
            winFrameIndex: number = winFrameData.winFrameIndex,
            symId: number = winFrameData.symbolId,
            resizedReel: boolean = winFrameData.resizedReel,
            isSingleSymInEnhancer: boolean = winFrameData.singleSymbolInEnhancer,
            animName: string = winFrameData.animName,
            winItem: PIXI.spine.Spine = this._winItems[winFrameIndex];

        let usableHeight: number = winFrameData.symbolHeight;

        if ((reelId === 1 || reelId === 3) && symId === 2 && !resizedReel) {
            usableHeight = isSingleSymInEnhancer ? 99 : 45;
        }

        MentalWinHighlightView.resetWinItemTemp(winItem, winFrameData);

        winItem.state.setAnimation(0, animName, false).timeScale = winFrameData.timeScale;

        // we have to set the height after setting the state, and we need the updateTransform method to let this height take effect.
        winItem.height = (usableHeight * 1.70772727);
        winItem.updateTransform();
    }

    public stopWinItems(): void {
        for (let i: number = 0; i < this._winItems.length; i++) {
            const winItem: PIXI.spine.Spine = this._winItems[i];

            winItem.visible = false;
            winItem.state.clearTracks();
        }
    }

    private init(): void {
        const maxPossibleSymbols: number = 80,
            spineName: string = "winHighlight";

        for (let i: number = 0; i < maxPossibleSymbols; i++) {
            const item: PIXI.spine.Spine = new PIXI.spine.Spine(Mental.assetLoader.getSpineAsset(spineName));
            item.visible = false;
            this._winItems.push(item);
            this.addChild(item);
        }
    }
}